import React, { useState } from 'react';
import UserGroups from './userGroups';
import GroupDetails from './groupDetails';
import UserDetails from './userDetails';
import toastService from '../../services/toastService';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { put, post } from '../../utils/apiUtils';
import { useNavigate } from 'react-router-dom';
import { createUserGroup, updateUserGroup } from '../../services/groupService';
import { useToast } from './ToastProvider';

const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

const BackButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: var(--primary);
  padding: 0.5rem 0.8rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  &:hover {
    background: rgba(0, 102, 255, 0.1);
    transform: translateX(-4px);
  }
`;

const BackText = styled.span`
  font-size: 0.9rem;
  font-weight: 500;
`;

export const StepIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  background: ${props => {
    if (props.active) return 'var(--primary)';
    if (props.completed) return 'var(--success)';
    return 'rgba(0, 102, 255, 0.1)';
  }};
  color: ${props => (props.active || props.completed) ? 'white' : 'var(--primary)'};
`;

export const StepContent = styled.div`
  flex: 1;
`;

export const StepTitle = styled.div`
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 0.3rem;
`;

export const StepDescription = styled.div`
  font-size: 0.8rem;
  color: var(--text-secondary);
`;

const GroupUserNavComponent = ({ onDeepNavigation, onNavigationBack }) => {
  const [activePage, setActivePage] = useState('groupListing');
  const [groupVisible, setGroupVisible] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [navigationBreadcrumb, setNavigationBreadcrumb] = useState(['groups']);
  const navigate = useNavigate();
  const {showToast} = useToast()

  const showValidationErrors = (error) => {
    if (error.response && error.response.data && error.response.data.detail) {
      const errors = error.response.data.detail;
      errors.forEach(validationError => {
        const fieldName = validationError.loc[validationError.loc.length - 1];
        const message = validationError.msg;
        toastService.error(`${fieldName}: ${message}`);
      });
    } else {
      toastService.error('An error occurred while saving the user');
    }
  };

  const handleSelectGroup = (group, isGroupVisible) => {
    setSelectedGroup(group);
    setGroupVisible(isGroupVisible)
    setActivePage('groupDetails');
    if (onDeepNavigation) {
      onDeepNavigation(['userGroups', 'groupDetails']);
    }
    setNavigationBreadcrumb(['groups', 'groupDetails']);
  };


  const handleSelectUser = (user, currentGroup) => {
    setSelectedUser(user);
    setSelectedGroup(currentGroup)
    setActivePage('userDetails');
    if (onDeepNavigation) {
      onDeepNavigation(['userGroups', 'userDetails']);
    }
    setNavigationBreadcrumb(['groups', 'groupDetails', 'userDetails']);
  };

  const handleCancelUser = () => {
    setSelectedUser(null);
    setActivePage('groupDetails');
  };

  const handleBackToGroupListing = () => {
    setSelectedGroup(null);
    setActivePage('groupListing');
  };

  // const handleSaveGroup = async (groupDetails) => {
  //   if (groupDetails && groupDetails.id) {
  //     try {
  //       const updateResponse = await put(`/api/v1/mms_persistence/user_group`, groupDetails, {
  //         withCredentials: true,
  //       });
  //       setSelectedGroup(updateResponse);
  //       navigate('/manage')
  //     } catch (error) {
  //       console.error('Error updating group:', error);
  //     }
  //   } else {
  //     try {
  //       const createResponse = await post(`/api/v1/mms_persistence/user_group`, groupDetails, {
  //         withCredentials: true,
  //       });
  //       setSelectedGroup(createResponse);
  //       navigate('/manage')
  //     } catch (error) {
  //       console.error('Error updating group:', error);
  //     }
  //   }
  // };


  const handleSaveGroup = async (groupDetails) => {
    if (groupDetails && groupDetails.id) {
      try {
        const updateResponse = await updateUserGroup(groupDetails);
        setSelectedGroup(updateResponse);
        handleBack()
      } catch (error) {
        showToast({
          type:'error',
          message: 'Error while updating the gruop.'
        })
        console.error('Error updating group:', error);
      }
    } else {
      try {
        const createResponse = await createUserGroup(groupDetails)
        setSelectedGroup(createResponse);
        handleBack();
      } catch (error) {
        console.error('Error updating group:', error);
           showToast({
          type:'error',
          message: 'Error while saving the gruop.'
        })
      }
    }
  };

  //comented this because alreday made a call from userdetila page
  // const handleSaveUser = async (userDetails) => {
  //   console.log('Save User:', userDetails);
  //   if (userDetails && userDetails.id) {
  //     try {
  //       const updateResponse = await put(`/api/v1/mms_persistence/users`, userDetails, {
  //         withCredentials: true,
  //       });
  //       setSelectedUser(updateResponse);
  //       setActivePage('groupDetails');
  //       toastService.success('User updated successfully');
  //     } catch (error) {
  //       console.error('Error updating user:', error);
  //       showValidationErrors(error);
  //     }
  //   } else {
  //     try {
  //       userDetails.username = userDetails.email;
  //       const createResponse = await post(`/api/v1/mms_persistence/users`, userDetails, {
  //         withCredentials: true,
  //       });
  //       setSelectedUser(createResponse);
  //       try {
  //         let payload = {
  //           group: selectedGroup.name,
  //           entity_id: createResponse.username,
  //           company_cd: createResponse.company_cd,
  //           entity_type: 'user'
  //         }
  //         const linkageResponse = await post(`/api/v1/mms_persistence/user_group_mapping`, payload, {
  //           withCredentials: true,
  //         });
  //         setActivePage('groupDetails');

  //         setNavigationBreadcrumb(['groups', 'groupDetails']);
  //         toastService.success('User created and added to group successfully');

  //       } catch (error) {
  //         console.error('Error updating group Linkage:', error);
  //         toastService.error('User created but failed to add to group');
  //       }
  //     } catch (error) {
  //       console.error('Error creating user:', error);
  //       showValidationErrors(error);
  //     }
  //   }
  // };

  const handleBack = () => {
    const currentBreadcrumb = navigationBreadcrumb;
    
    if (activePage === 'userDetails') {

      setActivePage('groupDetails');
      setSelectedUser(null);
      setNavigationBreadcrumb(['groups', 'groupDetails']);
      if (onDeepNavigation) {
        onDeepNavigation(['userGroups', 'groupDetails']);
      }
    } else if (activePage === 'groupDetails') {
      setActivePage('groupListing');
      setSelectedGroup(null);
      setSelectedUser(null);
      setNavigationBreadcrumb(['groups']);
      if (onDeepNavigation) {
        onDeepNavigation(['userGroups']);
      }
    }
  };

  const getBackButtonText = () => {
    if (activePage === 'userDetails') {
      return `Back to ${selectedGroup?.group || 'Group'}`;
    } else if (activePage === 'groupDetails') {
      return 'Back to Groups';
    }
    return 'Back';
  };


  const showBackButton = activePage !== 'groupListing';
  return (
    <div>

      {showBackButton && (
        <BackButtonContainer>
          <BackButton onClick={handleBack}>
            <FontAwesomeIcon icon={faArrowLeft} />
            <BackText>{getBackButtonText()}</BackText>
          </BackButton>
        </BackButtonContainer>
      )}

      {activePage === 'groupListing' && <UserGroups onSelectGroup={handleSelectGroup} onSelectUser={handleSelectUser} />}
      {activePage === 'groupDetails' && (
        <GroupDetails
          groupItem={selectedGroup}
          onSelectUser={handleSelectUser}
          onSaveGroup={handleSaveGroup}
          onBackToGroupListing={handleBackToGroupListing}
          isGroupVisible={groupVisible}
        />
      )}
      {activePage === 'userDetails' && (
        <UserDetails 
          user={selectedUser} 
          handleBack={handleBack}
          onCancelUser={handleCancelUser}
          selectedGroup={selectedGroup?.group} 
        />
      )}
    </div>
  );
};

export default GroupUserNavComponent;